export const KUDOS_CAROUSEL_PAGE_SIZE = 3
export const KUDOS_DASHBOARD_PAGE_SIZE = 50
export const KUDOS_VISIBILITY_PAGE_SIZE = 50
